"use client";

import { useT } from "@tillix/i18n/react";
import { cn } from "@tillix/ui-atoms/lib/utils";
import { QuickPayButton } from "./quick-pay-button";

interface QuickPaySectionProps {
  textClassName?: string;
}

export const QuickPaySection: React.FC<QuickPaySectionProps> = ({
  textClassName,
}) => {
  const { t } = useT();
  return (
    <>
      <h2
        className={cn(
          "mb-1 font-semibold text-white text-xs uppercase md:text-sm",
          textClassName,
        )}
      >
        {t("auth.quickPay")}
      </h2>
      <p className={cn("mb-2 text-white text-xs md:text-sm", textClassName)}>
        {t("auth.quickPayDescription")}
      </p>
      <QuickPayButton className="w-full lg:size-lg" />
    </>
  );
};
